var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom"},[_c('p',{staticClass:"custom_top",attrs:{"id":"custom_link"},on:{"click":_vm.handleChat}},[_c('img',{attrs:{"src":require("./../../assets/login/qiyu.png"),"alt":"客服"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0def8f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer-board/index.vue
// module id = 0bna
// module chunks = 25